<template>
  <DBox
    :id="'cmp-booking-sidewindow-tasks_list'"
    :addButton="false"
    :searchButton="true"
    :searchFlag="searchFlag"
    :badgeButtons="
      filterExists
        ? [
            {
              text: 'Reset Filters',
              value: 'reset_filters',
              icon: 'delete-white',
            },
          ]
        : []
    "    
    :leftMenu="[
            { text: `+ ${$t('load_tasks')}`, value: 'load_tasks' },
            { text: `+ ${$t('add_task')}`, value: 'add_task' },
          ]"
    @menuClick="onRightMenuClick"
    @badgeClick="onBadgeClick"
    @searchClick="onSearchClick"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            width: '124px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
      <!-- <button @click="onApplyFilter" class="dt-button dt-button v5 s8 m8">
        Apply Filter
      </button> -->
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined,
      }"
    >
      <NTable
        class="dbox1"
        id="booking-booking_details-sidewindow-tasks_list"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :showNoItems="false"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('task')" @click.stop="(e) => ontaskItemClicked(item)">
              <span class="txtov ut-link ut-text-accent5" :title="item['task']">
                {{ item["task"] }}
              </span>
            </td>
            <td v-bind="tdcon('status')">
              <Dropdown2
                class="dbox1"
                :options="taskStatusTV"
                :showLabel="false"
                :placeholder="$t('status')"
                :selected="
                  taskStatusTV.find(
                    (s) => s.value == item['status']
                  )
                "
                v-on:selectedChange="(e) => onTaskStatusChange(item, e)"
                :style="{
                  maxWidth: '100%',
                  width: '100%',
                }"
                bb="0"
              ></Dropdown2>
            </td>
            <td v-bind="tdcon('due_date')">
              <span class="txtov">
                {{ item["due_date"] }}
              </span>
            </td>
            <td v-bind="tdcon('users')">
              <span class="txtov">
                {{ item["users"] }}
              </span>
            </td>
            <td v-bind="tdcon('notes')">              
              <TextField2
                class="dbox1"
                :id="'notes'"
                :showLabel="false"
                :value="item['notes']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => onUserTaskDelete(item)"
                class="dt-icon v5 s1 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { BookingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { bookingsActions } from "../../store/bookings/actions";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import {
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
  },
  props: ["booking"],
  data: function () {
    return {
      searchFlag: false,
      searchModel: {
        str: "",
      },
      searchString: "",
      searchSubject$: new Subject(),
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  mounted() {   
    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(debounceTime(500), distinctUntilChanged()),
      (searchString) => {
        this.searchModel = {
          ...this.searchModel,
          str: searchString,
        };
        this.searchString = searchString;
        this.onApplyFilter();
      }
    );
  },
  computed: {
    list: function () {
      return this?.booking?.task_list || [];
    },
    headers: function () {
      return [
        createTableHeader("task", {
          // text: "Task",
          f: 1.7,
          // mw: 200,
        }),
        createTableHeader("status", {
          // text: "Status",
          ta: "left",
          f: 0.5,
        }),
        createTableHeader("due_date", { ta: "left" }),
        createTableHeader("users"),
        createTableHeader("notes", {
          text: "Notes",
          // ta: "right",
          // minw: 40,
          // mw: 100,
        }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    filterExists() {
      return this.searchModel.str ? true : false
    },
    taskStatusTV: function () {
      return createTV(
        (this?.booking?.task_statuses || []).map((r) => ({ text: r, value: r })),
        "text",
        "value"
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, bookingsActions),
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        item
      });
    },
    onTaskStatusChange: function (item, e) {
      this.onTextFieldValueChange({name: "status", value: e.value}, item);
    },
    onRightMenuClick: async function (menu) {
      this.$emit('menu', menu);
    },
    onUserTaskDelete: async function (item) {
      this.$emit('delete', item);
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit("showSearchFlag", this.searchFlag);
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        this.searchString = "";
        this.searchModel = {
          str: ""
        };
        this.onApplyFilter();
        this.searchFlag = false;
        this.$emit("showSearchFlag", this.searchFlag);
      }
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchModel = {
        ...this.searchModel,
        str: this.searchString,
      };
      this.searchSubject$.next(event.target.value);
    },
    async onApplyFilter() {
      this[ActionTypes.BDTaskList.FETCH.ALL]({search: this.searchModel.str, calendar_date_id: this.booking.cdate.calendar_date_id});
    },
    ontaskItemClicked(item){
      openModalRoute(this, "task_details", {
        task_id: item.task_id,
      });
    }
  },
};
</script>

<style lang="scss">
.cmp-booking-sidewindow-tasks_list {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
    .dropdown {
      margin: 10px;
    }
  }
}
</style>
